<!--
 * @Author: your name
 * @Date: 2020-07-08 15:42:25
 * @LastEditTime: 2020-07-27 10:32:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Parts_APP\src\views\myhome\index.vue
-->
<template>
    <div class="deviceList">
        <div class="clearfix">
            <van-nav-bar
                class="restclass"
                title="我 的"
                left-text="返回"
                left-arrow
                @click-left="getBack" />
        </div>
        <van-form class="form">
            <van-field v-model="displayName" :required="true" :readonly="true" label="姓名" />
            <van-field v-model="loginName" :required="true" :readonly="true" label="账号" />
        </van-form>
        <bottom />
    </div>
</template>

<script>
import { Icon, Form, Field, Button, Col, Row } from 'vant'
import bottom from '@/components/bottom'
import { getUserInfo } from '@/api/user'
export default {
    name: 'MyHome',
    components: {
        bottom,
        Icon, [Field.name]: Field, [Form.name]: Form, [Button.name]: Button, [Col.name]: Col, Row
    },
    data() {
        return {
            displayName: '',
            loginName: ''
        }
    },
    created() {
        getUserInfo().then(res => {
            if (res.code==200) {
                this.displayName = res.user.nickName
                this.loginName = res.user.userName
            }
        })
    },
    methods: {
        // 回退
        getBack() {
            this.$router.push({path:'/'})
        }
    }
}
</script>

<style lang='scss' scoped>
.nav{
  width: 100%;
  padding: 20px 0px;
  background: #3498ff;
  color: #fff;
  .nav-title{
    width: 100%;
    font-size: 30px;
    text-align: center;
    display: block;
  }
}
.deviceList{
  width: 100%;
  .logout{
    margin-top: -20px;
    color: blue;
  }
}
</style>
<style lang='scss' >
// .form .van-cell{
//     line-height: 0.6rem !important;
// }
.form{
    margin: 10px 0;
}
.form .van-cell__title{font-size: 0.4rem !important;}

</style>
